<template>
    <div class="marker-map-wrapper d-flex flex-column align-items-end w-100 gap-2 border-radius-10" style="height: 100%;">
        <div id="map" :style="[{'--height': height}]">
        </div>
    </div>
</template>
<!-- <primaryButtonComponent buttonType="submit" @click="resetMap" class="large-text mt-4" buttonWidth="max-content" paddingY="10px" paddingX="18px">
    <template v-slot:content>
        reset
    </template>
</primaryButtonComponent> -->
<script>
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { toRaw, isProxy } from "vue";
export default {
    data(){
        return {
            map: null,
            advancedMarker: null,
            pinElement: null,
            infoWindow: null,
            infoWindowElement: null,
            markerCluster: null,
            center: { lat: 42.01674161706719, lng: 44.070112500000015 },
            markerArray: [],
            polygonElementsArray: [],
            currentlyClickedPolygon: null,
            currentlyClickedPolygonIndex: null,
        }
    },
    props: {
        currentCenter: {
            type: Object,
            default: {},
        },
        height: {
            type: String,
            default: "400px",
        },
        markersInfo: {
            type: Array,
            default: [],
        },
        polygonsArray: {
            type: Array,
            default: [],
        },
        polygonColorsArray: {
            type: Array,
            default: [
                {
                    strokeColor: "#008000",
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    fillColor: "#ffffff00",
                    fillOpacity: 0.7,
                },
                {
                    strokeColor: "#008000",
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    fillColor: "#008000",
                    fillOpacity: 0.7,
                }
            ],
        },
        zoomOn: Number,
        allowUnZoom: {
            type: Boolean,
            default: true,
        },
        zoomLevel: {
            type: Number,
            default: 19,
        },
        unzoomMapLevel: {
            default: 0,
            type: Number,
        },
        activeOn: Number,
        standardMarkerConf: {
            type: Object,
            default: {
                scale: 1,
                background: "#008000",
                borderColor: "white",
                glyphColor: "white",
            },
        },
        activeMarkerConf: Object,
        polygonPusher: Boolean,
        maximumClusterRadiusInPixels: {
            type: Number,
            default: 70,
        },
        clusterBgColors: {
            type: Array,
            default: [
                "#1FD286",
                "#1E5EFF",
                "#FFCB10",
                "#F32E21",
            ]
        },
    },
    watch: {
        polygonsArray: {
            handler(){
                this.polygonElementsArray = [];
                this.allocatePolygonsOnMap();
            },
            deep: true,
        },
        markersInfo: {
            handler(newArray){
                if(this.map != null){
                    this.markerArray.forEach((marker) => {
                        marker.setMap(null);
                    });
                    this.markerArray = [];
                    this.allocateMarkersOnMap();
                }
            },
            deep: true,
        },
        zoomOn: {
            handler(newIndex){
                
                if((newIndex !== null || newIndex == 0) && this.markerArray[newIndex]){
                    this.setZoomOnMarker(newIndex, true);
                }else if(this.allowUnZoom){
                    this.unzoomMap();
                }
            },
            deep: true,
            immediate: true,
        },
        activeOn: {
            handler(newIndex){
                if(newIndex != null){
                    this.makeMarkerActiveOnIndex(newIndex);
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted(){
        this.loadMapsJavascriptApi();
    },
    methods: {
        giveClickedPolygonColor(polygon, index){
            if(this.currentlyClickedPolygon){
                this.currentlyClickedPolygon.setOptions({
                    fillColor: this.polygonColorsArray[0].fillColor,
                });
            }
            polygon.setOptions({
                fillColor: this.polygonColorsArray[1].fillColor,
            });
            
            this.currentlyClickedPolygon = polygon;
            this.currentlyClickedPolygonIndex = index;

        },
        allocatePolygonsOnMap(){
            
            this.polygonsArray.forEach((polygonObj, index) => {

                let polygonPath = polygonObj?.polygons?.map((latLng) => {
                    return {lat: latLng[0], lng: latLng[1]};
                });
                
                const polygon = new google.maps.Polygon({
                    ...this.polygonColorsArray[0],
                    paths: polygonPath,
                    geodesic: true,
                });

                polygon.setMap(toRaw(this.map));
                google.maps.event.addListener(polygon, 'mouseover', () => {
                    polygon.setOptions({
                        fillColor: this.polygonColorsArray[1].fillColor,
                    });
                });

                google.maps.event.addListener(polygon, 'mouseout', () => {
                    let closureIndex = index;
                    if(this.currentlyClickedPolygonIndex != closureIndex){
                        polygon.setOptions({
                            fillColor: this.polygonColorsArray[0].fillColor,
                        });
                    }
                });


                polygon.addListener("click", () => {
                    let closureIndex = index;
                    
                    this.$emit("exposePolygon", polygonObj.ID);
                    this.zoomOnPolygon(polygon);
                    this.giveClickedPolygonColor(polygon, closureIndex);
                });
                
                this.polygonElementsArray.push(polygon);
                
            })
        },
        zoomOnPolygon(polygon){
            // new google.maps.LatLng(37.782, -122.447),
            var bounds = new google.maps.LatLngBounds();

            polygon.getPath().forEach(function(latlng) {
                bounds.extend(latlng);
            });

            toRaw(this.map).fitBounds(bounds);
        },
        
        makeMarkerActiveOnIndex(newIndex){
            const pinScaled = new this.pinElement({
                scale: 1.5,
                background: "red",
                borderColor: "red",
                glyphColor: "white",
            });
            this.markerArray[newIndex].content = pinScaled.element;
            this.markerArray[newIndex].zIndex = 2;
        },
        setZoomOnMarker(newIndex, includeInfoWindow){
            if(newIndex || newIndex == 0){
                setTimeout(() => {
                    this?.infoWindowElement?.close();
                    toRaw(this.map).setCenter(this.markerArray[newIndex]?.position);
                    toRaw(this.map).setZoom(this.zoomLevel);
                    if(includeInfoWindow){
                        let infoWindowElementContent = `<p class="font-weight-600 text-start">${this.markersInfo[newIndex]?.name}</p>` + `<div class="text-start">${this.markersInfo[newIndex]?.address}</div>` + `<div class="text-start">${this.markersInfo[newIndex]?.comment}</div>` ;
                        this.infoWindowElement.setContent(infoWindowElementContent);
                        this.infoWindowElement.open({
                            anchor: this.markerArray[newIndex],
                            map: toRaw(this.map)
                        })
                    }
                    
                }, 100);
            }
        },
        forceMapUpdate(){
            google.maps.event.trigger(this.map, "idle");
        },
        allocateMarkersOnMap(){
            if(this.markerCluster){
                this.markerCluster.clearMarkers(true); // ***<><><>
            }
            
            setTimeout(() => {
                this.markersInfo?.forEach((markerInfo) => {
                    if(markerInfo.latLng.lat){
                        let localeConf = {...this.standardMarkerConf};
                        if(markerInfo?.background){
                            localeConf.background = markerInfo?.background;
                        }
                        const pinScaled = new this.pinElement(localeConf);
                        const marker = new this.advancedMarker({
                            map: toRaw(this.map),
                            position: markerInfo.latLng,
                            content: pinScaled.element,
                        });
                        marker.addListener("gmp-click", () => {
    
                            this.infoWindowElement.close();
                            let infoWindowContent = `<p class="font-weight-600 text-start">${markerInfo?.name}</p>` + `<div class="text-start"><pre>${markerInfo?.address}</pre></div>`+ `<div class="text-start">${markerInfo?.comment}</div>`;
                            this.infoWindowElement.setContent(infoWindowContent);
                            this.infoWindowElement.open({
                                anchor: marker,
                                map: toRaw(this.map),
                            });
                            this.$emit("getMarkerInfo", markerInfo.ID);
                        });
                        marker.addEventListener("mouseenter", () => {
                            this.infoWindowElement.close();
                            let infoWindowContent = `<p class="font-weight-600 text-start">${markerInfo?.name}</p>` + `<div class="text-start"><pre>${markerInfo?.address}</pre></div>`+ `<div class="text-start">${markerInfo?.comment}</div>`;
                            this.infoWindowElement.setContent(infoWindowContent);
                            this.infoWindowElement.open({
                                anchor: marker,
                                map: toRaw(this.map),
                            });
                        });
                        // marker.addEventListener("mouseleave", () => {
                        //     this.infoWindowElement.close();
                        // });
                        this.markerArray.push(marker);
                    }
                });
                this.markerCluster = new MarkerClusterer({ markers: this.markerArray, map: toRaw(this.map), 
                    renderer: this.getMarkerClusterRenderer(),
                });
                if(this.zoomOn || this.zoomOn == 0){
                    this.setZoomOnMarker(this.zoomOn, false);
                    
                }else if(this.allowUnZoom){
                    this.unzoomMap();
                }
                setTimeout(() => this.forceMapUpdate(), 50); // ***<><><>
            }, 100)
        },
        getClusterBgColor(ratio){
            return this.clusterBgColors.find((color, i) => {
                
                if(ratio > i / this.clusterBgColors.length && ratio <= (i + 1) / this.clusterBgColors.length){
                    return true;
                }
            });
        },
        getMarkerClusterRenderer(){
            let maxRadius = this.maximumClusterRadiusInPixels;
            const colorFunc = this.getClusterBgColor;
            return {
                render ({ count, position }, stats) {
                
                let radius = count / stats.clusters.markers.sum * maxRadius;
                radius = radius < 20?20:radius;
                let diemeter = 2 * radius;
                
                
                
                
                const svg = window.btoa(`
                    <svg fill="${colorFunc(count / stats.clusters.markers.sum)}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${diemeter} ${diemeter}">
                        <circle cx="${radius}" cy="${radius}" opacity=".8" r="${radius /2}" />  
                        <circle cx="${radius}" cy="${radius}" opacity=".6" r="${radius *4/5}" />    
                        <circle cx="${radius}" cy="${radius}" opacity=".4" r="${radius}" />    
                    </svg>`);
                // create marker using svg icon
                return new google.maps.Marker({
                    position,
                    icon: {
                        url: `data:image/svg+xml;base64,${svg}`,
                        scaledSize: new google.maps.Size(diemeter, diemeter),
                        anchor: new google.maps.Point(radius, radius),
                    },
                    label: {
                        text: String(count),
                        color: "rgba(255,255,255,0.9)",
                        fontSize: "16px",
                    },
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            }}
        },
        unzoomMap(){
            this.map?.setOptions({
                zoom: this.unzoomMapLevel,
                center: Object.keys(this.currentCenter).length > 1? this.currentCenter: this.center,
            });
        },
        async initMap(){
            const { Map, InfoWindow } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
            this.advancedMarker = AdvancedMarkerElement;
            this.pinElement = PinElement;
            this.infoWindow = InfoWindow;
            this.infoWindowElement = new this.infoWindow({
                maxWidth: 250,
            });
            var allowedBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(40.478072, 38.492964),
                new google.maps.LatLng(44.254719, 48.130206) 
            );
            this.map = await new google.maps.Map(document.getElementById("map"), {
                center: this.center,
                zoom: 2,
                mapId: "map",
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: true,
                // minZoom: 8,
                mapTypeId: "roadmap",
                restriction: {
                    latLngBounds: allowedBounds,
                    strictBounds: true,
                }
            });
            google.maps.event.addListenerOnce(toRaw(this.map), 'idle', () => {
            });
            this.polygonElementsArray = [];
            this.allocatePolygonsOnMap();
            
            this.allocateMarkersOnMap();
        },
        async loadMapsJavascriptApi(){
            const loader = new Loader({
                apiKey: "AIzaSyAAKLfrixiIVwDf2VU31OdWZuxQswrTNA0",
                version: "beta",
                language: "GE",
                region: "GE",
                authReferrerPolicy: "origin",
            });
            await loader.importLibrary('maps').then(({Map}) => {
                this.initMap();
            })
            .catch((e) => {
                document.getElementById("map").textContent = "რუკა ვერ ჩაიტვირთა, დაფიქსირდა შეცდომა";
            });
        },
    }
}
</script>
<style>
.marker-map-wrapper{
    /* padding: 20px; */
    background-color: var(--secondary-background-color);
}
#map{
    height: var(--height);
    width: 100%;
}
</style>